module.exports = __webpack_public_path__ + "static/media/leasBigPic.e3e636b6.jpeg";